module.exports = __webpack_public_path__ + "img/selected5-min.5df16f55.png";